import { useEffect } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Amenities from "@/components/Amenities";
import Gallery from "@/components/Gallery";
import Breakfast from "@/components/Breakfast";
import Surroundings from "@/components/Surroundings";
import Reviews from "@/components/Reviews";
import HouseRules from "@/components/HouseRules";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="grain min-h-screen bg-[#FAF7F2] text-stone-900">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Amenities />
          <Gallery />
          <Breakfast />
          <Surroundings />
          <Reviews />
          <HouseRules />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
